import React from "react";
import { Alert } from "@material-ui/lab";
import { decimalFixed } from "../../../../utils/consts";
import { formatDecimalNumber } from "../../../../utils/format";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";
import { NavLink } from "react-router-dom";

const CashFlowBalancesHistoryList = ({ balancesHistory }) => {
  const { t } = useTranslation("cashFlow");

  if (!balancesHistory) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (balancesHistory.length === 0) {
    return <Alert severity="warning">{t("balancesHistory.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable className="balance-history-table_scroll">
      <StyledTable
        width="1440"
        size="16"
        className="balance-history-table"
      >
        <StyledTableHead
          scroll="auto"
          col="7"
          className="balance-history-table__head"
        >
          <div>
            {t("balancesHistory.table.user")}
          </div>
          <div>
            {t("balancesHistory.table.service")}
          </div>
          <div>
            {t("balancesHistory.table.currency")}
          </div>
          <div>
            {t("balancesHistory.table.balance")}
          </div>
          <div>
            {t("balancesHistory.table.date")}
          </div>
          <div>
            {t("balancesHistory.table.operationType")}
          </div>
          <div>
            {t("balancesHistory.table.transactionId")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {balancesHistory && balancesHistory.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="7"
              className="balance-history-table__row"
            >
              <StyledCol
                data-title={t("balancesHistory.table.user")}
                inline
              >
                <StyledBreakWord as="p">
                  <p>
                    Nickname: {value.nickname ?? '--'}
                  </p>
                  <p>
                    Email: {value.user}
                  </p>
                </StyledBreakWord>
              </StyledCol>
              <StyledCol data-title={t("balancesHistory.table.service")}>
                {value.service}
              </StyledCol>
              <StyledCol data-title={t("balancesHistory.table.currency")}>
                {value.currency}
              </StyledCol>
              <StyledCol className="balance-history-table__amount" data-title={t("balancesHistory.table.balance")}>
                <StyledBreakWord as="p">
                  {formatDecimalNumber(value.amount, decimalFixed)}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol data-title={t("balancesHistory.table.date")}>
                {TimestampToDateMoment(value.createAt / 1000)}
              </StyledCol>
              <StyledCol data-title={t("balancesHistory.table.operationType")}>
                {value.operationType}
              </StyledCol>
              <StyledCol
                data-title={t("balancesHistory.table.transactionId")}
                inline
              >
                <NavLink
                  className="table-action table-action_info"
                  target="_blank"
                  to={"/" + value.operationType + "s/" + value.operationId}
                >
                  <StyledBreakWord as="p">
                    {value.operationId}
                  </StyledBreakWord>
                </NavLink>
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default CashFlowBalancesHistoryList;